<template>
  <div style="overflow: hidden;height:100%;">
    <el-container style="border: 1px solid #eee;overflow: hidden;height:100%;">
      <el-aside width="200px"
                class="left_nav_menus">
        <el-menu :default-active="activeIndex"
                 @select="clickLeftMenu">
          <el-menu-item index="1"><i class="fa fa-users fa-fw fa-lg"
               aria-hidden="true"></i>&nbsp; 成员</el-menu-item>
          <el-menu-item index="2"><i class="fa fa-file-text-o fa-fw fa-lg"
               aria-hidden="true"></i>&nbsp; 文件</el-menu-item>
          <el-menu-item index="4"><i class="fa fa-commenting fa-fw fa-lg"
               aria-hidden="true"></i>&nbsp; 短信</el-menu-item>
          <el-menu-item index="5"
                        v-if="role === 2"><i class="fa fa-upload"
               aria-hidden="true"></i>&nbsp; 导出日志</el-menu-item>
          <el-menu-item index="3"><i class="fa fa-wrench fa-fw fa-lg"
               aria-hidden="true"></i>&nbsp; 设置</el-menu-item>
        </el-menu>
      </el-aside>

      <el-container style="overflow-y:auto;overflow-x:hidden;">
        <div style="padding:20px;width:100%;">
          <router-view></router-view>
        </div>
      </el-container>
    </el-container>

  </div>
</template>

<script>
// import Cookies from 'js-cookie'
export default {
  data() {
    return {
      activeIndex: '1',
      role: this.$common.getLoginInfo().role,
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.path.startWith('/manager/members')) {
        vm.activeIndex = '1'
      }
      if (to.path.startWith('/manager/files')) {
        vm.activeIndex = '2'
      }
      if (to.path.startWith('/manager/setting')) {
        vm.activeIndex = '3'
      }
      if (to.path.startWith('/manager/smstemplate')) {
        vm.activeIndex = '4'
      }
      if (to.path.startWith('/manager/export-list')) {
        vm.activeIndex = '5'
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
      if (to.path.startWith('/manager/members')) {
        this.activeIndex = '1'
      }
      if (to.path.startWith('/manager/files')) {
        this.activeIndex = '2'
      }
      if (to.path.startWith('/manager/setting')) {
        this.activeIndex = '3'
      }
      if (to.path.startWith('/manager/smstemplate')) {
        this.activeIndex = '4'
      }
      if (to.path.startWith('/manager/export-list')) {
        this.activeIndex = '5'
      }
    next()
  },
  methods: {
    clickLeftMenu(index) {
      if (index == '1') {
        this.$router.push({
          path: '/manager/members',
        })
      }
      if (index == '2') {
        this.$router.push({
          path: '/manager/files',
        })
      }
      if (index == '3') {
        this.$router.push({
          path: '/manager/setting',
        })
      }
      if (index == '4') {
        this.$router.push({
          path: '/manager/smstemplate',
        })
      }
      if (index == '5') {
        this.$router.push({
          path: '/manager/export-list',
        })
      }
    },
  },
}
</script>

<style>
</style>
